export const en = {
  'website.description': 'Edit the public website, then publish when it looks right.',
  'website.publishedAt': 'Published {date}',
  'website.notPublished': 'Not published yet',
  'website.unpublishedChanges': 'Unpublished changes',
  'website.live': 'Live',
  'website.unsavedEdits': 'Unsaved edits',
  'website.saveToPreview': 'Save the draft to preview it',
  'website.previewDraft': 'Preview draft',
  'website.saveDraft': 'Save draft',
  'website.saveFirst': 'Save the draft first',
  'website.publish': 'Publish',
  'website.unpublish': 'Unpublish',
  'website.draftSaved': 'Draft saved',
  'website.published': 'Website published',
  'website.unpublished': 'Website unpublished',
  'website.quarantine.title': 'Your saved draft was set aside',
  'website.quarantine.body': "It no longer met the website's rules, so the editor opened a fresh draft instead. Your live site is not affected. Restore the last published version to keep working from it, or start from the fresh draft.",
  'website.quarantine.bodyNoRestore': "It no longer met the website's rules, so the editor opened a fresh draft instead. The set-aside draft is kept; Bulk support can recover it.",
  'website.quarantine.reason': 'What did not pass: {reason}',
  'website.quarantine.restore': 'Restore the last published version',
  'website.quarantine.dismiss': 'Start from this draft',
  'website.quarantine.restored': 'The last published version is back in the draft',
  'website.tab.sections': 'Sections',
  'website.tab.navigation': 'Navigation & footer',
  'website.tab.seo': 'SEO',
  'website.tab.social': 'Social',
  'website.tab.branding': 'Branding',
  'website.tab.memberArea': 'Member area',
  'website.memberArea.cardsTitle': 'Member home',
  'website.memberArea.cardsDescription': 'Drag the cards into the order members see them on their home page, and switch off the ones you do not want. Changes go live when you publish the website.',
  'website.memberArea.drag': 'Drag to reorder',
  'website.memberArea.show': 'Show {card}',
  'website.memberArea.moduleOff': 'Switched off for this gym, so members do not see it',
  'website.memberArea.card.announcements': 'Announcements and offers',
  'website.memberArea.card.membership': 'Membership status',
  'website.memberArea.card.profile': 'Profile',
  'website.memberArea.card.balance': 'Balance and top-up',
  'website.memberArea.card.actions': 'Buy, book a class, top up',
  'website.memberArea.card.visits': 'Recent visits',
  'website.memberArea.card.bookings': 'Upcoming bookings',
  'website.memberArea.card.entry': 'Entry cards',
  'website.memberArea.card.notifications': 'Notifications',
  'website.memberArea.card.documents': 'Documents',
  'website.memberArea.card.payments': 'Last payment',
  'website.memberArea.card.quickLinks': 'Quick links',
  'website.memberArea.card.trainers': 'Trainers',
  'website.memberArea.card.hours': 'Opening hours',
  'website.memberArea.card.barMenu': 'Bar menu',
  'website.memberArea.welcomeTitle': 'Welcome',
  'website.memberArea.welcome': 'Welcome message',
  'website.memberArea.welcomeHint': 'Shown above the cards, in each language. Markdown: bold, lists and links work.',
  'website.memberArea.hero': 'Hero image',
  'website.memberArea.heroHint': 'A wide picture shown above the welcome message.',
  'website.memberArea.links': 'Quick links',
  'website.memberArea.linksHint': 'Up to six links, shown in the Quick links card.',
  'website.memberArea.noLinks': 'No quick links yet.',
  'website.memberArea.addLink': 'Add a link',
  'website.memberArea.removeLink': 'Remove link',
  'website.memberArea.linkLabelEn': 'Label in English',
  'website.memberArea.linkLabelKa': 'Label in Georgian',
  'website.memberArea.linkHref': 'Link',
  'website.memberArea.linkIcon': 'Icon',
  'website.memberArea.badHref': 'Link to a page of the member area, starting with /, or to an address starting with http:// or https://.',
  'website.memberArea.icon.link': 'Link',
  'website.memberArea.icon.calendar': 'Calendar',
  'website.memberArea.icon.dumbbell': 'Dumbbell',
  'website.memberArea.icon.coffee': 'Coffee',
  'website.memberArea.icon.user': 'Person',
  'website.memberArea.icon.phone': 'Phone',
  'website.memberArea.icon.map': 'Map pin',
  'website.memberArea.icon.star': 'Star',
  'website.memberArea.icon.gift': 'Gift',
  'website.memberArea.icon.info': 'Information',
  'website.memberArea.preview': 'Preview',
  'website.memberArea.previewHint': 'The member home with a sample member, in your gym’s colours. It follows your edits before you save.',
  'website.memberArea.lookTitle': 'Look of the sign-in pages and member area',
  'website.memberArea.lookDescription': 'Set by Bulk in the design studio.',
  'website.memberArea.lookBulk': 'Bulk’s look',
  'website.memberArea.lookBulkHint': 'The sign-in pages and the member area keep Bulk’s own screens, with your fonts, corners and brand colours. Ask Bulk to switch them to your site’s look.',
  'website.memberArea.lookSite': 'The site’s look',
  'website.memberArea.lookSiteHint': 'On your own address the sign-in pages and the member area use your site’s logo, fonts, colours and corners. Staff addresses keep Bulk’s look.',
  'website.tab.redirects': 'Redirects',
  'website.redirects.cardTitle': 'Old addresses',
  'website.redirects.cardDescription': 'Send links to the gym’s old site (search results, Instagram bios, printed QR codes) on to where that content lives now. A path such as /gallery, or a hash route such as #/product. They go live when you publish.',
  'website.redirects.add': 'Add a redirect',
  'website.redirects.empty': 'No redirects',
  'website.redirects.emptyHint': 'Add one for each old address that still gets visitors.',
  'website.redirects.from': 'Old address',
  'website.redirects.to': 'Send to',
  'website.redirects.fromPlaceholder': '/gallery or #/product',
  'website.redirects.toPlaceholder': '/plans or https://…',
  'website.redirects.permanent': 'Permanent',
  'website.redirects.remove': 'Remove redirect',
  'website.redirects.badFrom': 'Start the old address with / or #/.',
  'website.redirects.badTo': 'Send to a path on this site, starting with /, or an address starting with https://.',
  'website.navigation.description': 'Links in the site header and the text at the bottom of every page.',
  'website.nav.links': 'Navigation links',
  'website.nav.linkItem': 'Link {n}',
  'website.nav.addLink': 'Add link',
  'website.nav.noLinks': 'No navigation links yet.',
  'website.nav.hrefHint': 'A path like /classes or a full URL',
  'website.nav.footerText': 'Footer text',
  'website.seo.cardTitle': 'Search engine settings',
  'website.seo.cardDescription': 'How the site appears in Google and when shared on social networks.',
  'website.seo.title': 'Page title',
  'website.seo.titleHint': 'Shown in the browser tab and search results.',
  'website.seo.description': 'Meta description',
  'website.seo.robotsIndex': 'Allow search engines to index the site',
  'website.seo.canonicalUrl': 'Canonical URL',
  'website.seo.canonicalUrlHint': 'Optional. Use when the site is reachable on several domains.',
  'website.seo.ogImage': 'Social sharing image',
  'website.social.cardTitle': 'Social profiles',
  'website.social.cardDescription': 'Shown in the footer. Leave a field empty to hide it.',
  'website.social.facebook': 'Facebook',
  'website.social.instagram': 'Instagram',
  'website.social.tiktok': 'TikTok',
  'website.social.youtube': 'YouTube',
  'website.publishTitle': 'Publish the website?',
  'website.publishDescription': 'The saved draft replaces what visitors currently see.',
  'website.unpublishTitle': 'Take the website offline?',
  'website.unpublishDescription': 'Visitors will see a placeholder until you publish again. Your draft is kept.',
  'website.servedFrom': 'The public site is served from {host} once published.',
  'website.servedFromYourDomain': 'The public site is served from your gym domain once published.',
  'website.branding.saved': 'Branding saved',
  'website.branding.title': 'Brand',
  'website.branding.description': 'Colours, font and logo used across the public website.',
  'website.branding.primary': 'Primary',
  'website.branding.primaryHint': 'Buttons, highlights and accents',
  'website.branding.primaryAria': 'Primary colour',
  'website.branding.secondary': 'Secondary',
  'website.branding.secondaryHint': 'Cards and secondary surfaces',
  'website.branding.secondaryAria': 'Secondary colour',
  'website.branding.background': 'Background',
  'website.branding.backgroundHint': 'Page background',
  'website.branding.backgroundAria': 'Background colour',
  'website.branding.text': 'Text',
  'website.branding.textHint': 'Body text on the background',
  'website.branding.textAria': 'Text colour',
  'website.branding.font': 'Font family',
  'website.branding.fontHint': 'Loaded from Google Fonts on the public site when available.',
  'website.branding.designed': "Bulk built this site's design",
  'website.branding.designedText': 'Its fonts, header, footer and colour schemes come from the design. The four colours here are what every scheme is made from, so a change shows across the whole site.',
  'website.branding.logo': 'Logo',
  'website.branding.logoHint': 'SVG or PNG with a transparent background.',
  'website.branding.favicon': 'Favicon',
  'website.branding.faviconHint': 'Square, at least 64×64.',
  'website.branding.save': 'Save branding',
  'website.branding.preview': 'Preview',
  'website.branding.sampleHeadline': 'Train harder at {gym}',
  'website.branding.sampleText': 'Memberships, classes and coaching under one roof.',
  'website.branding.sampleButton': 'Join now',
  'website.pages.home': 'Home',
  'website.pages.add': 'Add page',
  'website.pages.title': 'Page',
  'website.pages.description': 'Where this page lives and how it appears in the menu.',
  'website.pages.titleHint': 'Used in the browser tab and as the menu label unless you set one below.',
  'website.pages.address': 'Address',
  'website.pages.showInMenu': 'Show in the menu',
  'website.pages.showInMenuHint': 'Hidden pages still work if you link to them.',
  'website.pages.inSiteMenu': 'In the site menu',
  'website.pages.menuLabel': 'Menu label',
  'website.pages.menuLabelHint': 'Optional. Leave empty to use the title.',
  'website.pages.delete': 'Delete page',
  'website.pages.deleteTitle': 'Delete this page?',
  'website.pages.deleteDescription': 'Its sections are removed with it. Anyone following a link to the page will get a not-found page once you publish. To keep the page but take it out of the menu, turn off “In the site menu” instead.',
  'website.openLive': 'Live site',
  'canvas.title': 'Page preview',
  'canvas.show': 'Show the page',
  'canvas.hide': 'Hide the page',
  'canvas.device': 'Screen size',
  'canvas.device.desktop': 'Computer',
  'canvas.device.tablet': 'Tablet',
  'canvas.device.phone': 'Phone',
  'canvas.hidden': 'Hidden',
  'canvas.incomplete': 'Fill in what this block needs to see it here.',
  'canvas.empty': 'This page has no blocks yet. Add one from the library.',
  'sections.empty': 'No sections',
  'sections.visible': 'Visible',
  'sections.selectTitle': 'Select a section',
  'sections.selectHint': 'Pick a section on the left to edit its content.',
  'sections.heading': 'Heading',
  'sections.intro': 'Intro',
  'sections.body': 'Body',
  'sections.text': 'Text',
  'sections.image': 'Image',
  'sections.button': 'Button',
  'sections.hero.label': 'Hero',
  'sections.hero.description': 'The big opening banner with your headline and calls to action.',
  'sections.hero.subtitle': 'Subtitle',
  'sections.hero.image': 'Background image',
  'sections.hero.video': 'Background video URL',
  'sections.hero.videoHint': 'Optional MP4 or streaming URL',
  'sections.hero.primaryCta': 'Primary button',
  'sections.hero.secondaryCta': 'Secondary button',
  'sections.about.label': 'About',
  'sections.about.description': 'Who you are and what makes the gym special.',
  'sections.about.highlights': 'Highlights',
  'sections.about.highlightItem': 'Highlight {n}',
  'sections.about.addHighlight': 'Add highlight',
  'sections.about.noHighlights': 'No highlights yet.',
  'sections.plans.label': 'Plans',
  'sections.plans.description': 'Membership plans with prices and a buy button.',
  'sections.plans.showAll': 'Show every public plan',
  'sections.plans.showAllHint': 'Turn off to hand-pick plans below.',
  'sections.plans.pick': 'Plans to show',
  'sections.plans.groupByBranch': 'Group by branch',
  'sections.plans.groupByBranchHint': "Lists the plans under each branch's name, even when the gym has one. A plan valid at every branch shows under each.",
  'sections.plans.none': 'No public plans yet.',
  'sections.classes.label': 'Classes',
  'sections.classes.description': 'Group classes and the weekly timetable.',
  'sections.classes.showSchedule': 'Show the weekly schedule',
  'sections.trainers.label': 'Trainers',
  'sections.trainers.description': 'Your public coaching team.',
  'sections.facilities.label': 'Facilities',
  'sections.facilities.description': 'Equipment, areas and amenities.',
  'sections.facilities.item': 'Facility {n}',
  'sections.facilities.add': 'Add facility',
  'sections.facilities.none': 'No facilities yet.',
  'sections.gallery.label': 'Gallery',
  'sections.gallery.description': 'A grid of photos.',
  'sections.gallery.images': 'Images',
  'sections.gallery.removeImage': 'Remove image',
  'sections.gallery.addHint': 'Upload or pick an image to add it to the gallery.',
  'sections.testimonials.label': 'Testimonials',
  'sections.testimonials.description': 'Quotes from happy members.',
  'sections.testimonials.item': 'Testimonial {n}',
  'sections.testimonials.add': 'Add testimonial',
  'sections.testimonials.none': 'No testimonials yet.',
  'sections.testimonials.author': 'Author',
  'sections.testimonials.quote': 'Quote',
  'sections.testimonials.rating': 'Rating (1–5)',
  'sections.faq.label': 'FAQ',
  'sections.faq.description': 'Frequently asked questions.',
  'sections.faq.questions': 'Questions',
  'sections.faq.item': 'Question {n}',
  'sections.faq.add': 'Add question',
  'sections.faq.none': 'No questions yet.',
  'sections.faq.question': 'Question',
  'sections.faq.answer': 'Answer',
  'sections.contact.label': 'Contact',
  'sections.contact.description': 'Address, phone, opening hours and a contact form.',
  'sections.contact.address': 'Address',
  'sections.contact.hours': 'Opening hours',
  'sections.contact.showForm': 'Show the contact form',
  'sections.map.label': 'Map',
  'sections.map.description': 'Where to find you.',
  'sections.map.latitude': 'Latitude',
  'sections.map.longitude': 'Longitude',
  'sections.map.embedUrl': 'Map embed URL',
  'sections.map.embedUrlHint': 'Google Maps “Embed a map” link',
  'sections.richText.label': 'Text',
  'sections.richText.description': 'Free-form writing — headings, paragraphs, lists and links — for copy that fits none of the other sections.',
  'sections.richText.headingHint': 'Optional. Leave empty for text with no title above it.',
  'sections.richText.bodyHint': 'Markdown: # heading, **bold**, - list, [link](https://…).',
  'sections.richText.width': 'Width',
  'sections.menu.label': 'Menu',
  'sections.menu.description': 'The café and shop list. Items are managed under Menu; this section chooses what the page shows.',
  'sections.menu.categories': 'Categories',
  'sections.menu.categoriesHint': 'Leave empty to show every visible category.',
  'sections.menu.layout': 'Layout',
  'sections.menu.none': 'No menu categories yet — add them under Menu.',
  'sections.menu.category': 'Category',
  'sections.menu.hidden': '(hidden)',
  'sections.cta.label': 'Call to action',
  'sections.cta.description': 'A closing banner nudging visitors to join.',
  'sections.link.hint': 'A path like /plans or a full URL',
  'editor.title': 'Title',
  'editor.label': 'Label',
  'editor.link': 'Link',
  'editor.add': 'Add',
  'editor.remove': 'Remove',
  'editor.moveUp': 'Move up',
  'editor.moveDown': 'Move down',
  'editor.preview': 'Preview',
  'editor.nothingToPreview': 'Nothing to preview yet.',
  'media.asset': 'Asset {id}…',
  'media.upload': 'Upload',
  'media.svgUnreadable': 'This SVG could not be read. Save it again from your design tool, or upload a PNG.',
  'media.choose': 'Choose',
  'media.library': 'Media library',
  'media.uploadedAs.LOGO': 'Images uploaded as logo',
  'media.uploadedAs.FAVICON': 'Images uploaded as favicon',
  'media.uploadedAs.WEBSITE': 'Images uploaded as website',
  'media.uploadedAs.TRAINER': 'Images uploaded as trainer',
  'media.uploadedAs.GALLERY': 'Images uploaded as gallery',
  'media.uploadedAs.MEMBER': 'Images uploaded as member',
  'media.uploadedAs.DOCUMENT': 'Images uploaded as document',
  'media.empty.title': 'No images yet',
  'media.empty.description': 'Upload an image to start your library.',
  'content.description': 'Terms, privacy policy, refund policy, house rules, copyright and cookie notices, shown on the public site and accepted by members. The default texts follow common consumer-protection and data-protection practice; have a lawyer review them for your jurisdiction before publishing.',
  'content.newPage': 'New page',
  'content.empty.title': 'No pages yet',
  'content.empty.description': 'Create your terms, privacy policy and house rules so members can read and accept them.',
  'content.createPage': 'Create page',
  'content.col.page': 'Page',
  'content.col.slug': 'Slug',
  'content.col.kind': 'Kind',
  'content.col.accepted': 'Accepted',
  'content.col.updated': 'Updated',
  'content.view': 'View',
  'content.publish': 'Publish',
  'content.unpublish': 'Unpublish',
  'content.publishedVersion': 'Published version {version}',
  'content.unpublished': 'Page unpublished',
  'content.deleted': 'Page deleted',
  'content.created': 'Page created',
  'content.settingSaved': 'Setting saved',
  'content.publishNamed': 'Publish "{title}"?',
  'content.unpublishNamed': 'Unpublish "{title}"?',
  'content.deleteNamed': 'Delete "{title}"?',
  'content.unpublishDescription': "The page disappears from the public site and from members' documents. The draft is kept.",
  'content.deleteDescription': 'The draft will be removed. This cannot be undone.',
  'content.deletePage': 'Delete page',
  'content.gate.title': 'Require acceptance before online payment',
  'content.gate.hint': 'Members must accept every page marked "requires acceptance", at its current version, before they can pay online. Desk sales record the acceptance from the sale dialog instead.',
  'content.titleRequired': 'Add at least the English title',
  'content.newDescription': 'Pages start as drafts. Write the content in the editor, then publish.',
  'content.slugHint': 'Public address: /p/slug',
  'content.requiresAcceptance': 'Members must accept',
  'content.requiresAcceptanceHint': 'Asked again after every new version.',
  'content.showInFooter': 'Link in the site footer',
  'content.showInFooterHint': 'Once published.',
  'content.unsavedChanges': 'Unsaved changes',
  'content.viewPublic': 'View public page',
  'content.pageDescription': 'Address, type and where the page appears.',
  'content.readOnly': 'You can view this page but not change it.',
  'content.sortOrder': 'Sort order',
  'content.sortOrderHint': 'Lower comes first in the footer.',
  'content.content': 'Content',
  'content.contentDescription': 'Written in Markdown: # headings, - lists, **bold** and [links](https://…).',
  'content.bodyAria': 'Body ({language})',
  'content.version': 'Version',
  'content.published': 'Published',
  'content.draftUpdated': 'Draft updated',
  'content.publishVersion': 'Publish version {version}',
  'content.publishVersionTitle': 'Publish version {version}?',
  'content.publishThisTitle': 'Publish this page?',
  'content.unpublishThisTitle': 'Unpublish this page?',
  'content.hint.saveFirst': 'Save the draft before publishing.',
  'content.hint.upToDate': 'The public site shows the latest saved draft.',
  'content.hint.publishMakesPublic': 'Publishing makes the saved draft public.',
  'content.status.draft': 'Draft',
  'content.status.published': 'Published v{version}',
  'content.publishReaccept': 'The saved draft becomes version {next} on the public site. Members who accepted version {current} will be asked to accept version {next}.',
  'content.publishAccept': 'The saved draft becomes version {next} on the public site and members will be asked to accept it.',
  'content.publishPlain': 'The saved draft becomes version {next} on the public site.',
  'content.members.one': '{count} member',
  'content.members.other': '{count} members',
  'enum.contentPageKind.LEGAL': 'Legal',
  'enum.contentPageKind.PAGE': 'Page',
  'enum.contentPageKind.NOTICE': 'Notice',
  'menu.admin.intro': 'What the gym sells besides memberships — the café and shop list shown on the website. Nothing here is bought through Bulk.',
  'menu.admin.newCategory': 'New category',
  'menu.admin.empty.title': 'No menu yet',
  'menu.admin.empty.description': 'Add a category — drinks, food, supplements — then the items that go in it.',
  'menu.admin.addCategory': 'Add category',
  'menu.admin.untitled': 'Untitled',
  'menu.admin.hiddenBadge': 'Hidden',
  'menu.admin.hidden': 'hidden',
  'menu.admin.items.one': '{count} item',
  'menu.admin.items.other': '{count} items',
  'menu.admin.categoryVisible': 'Category is visible',
  'menu.admin.item': 'Item',
  'menu.admin.thisCategory': 'this category',
  'menu.admin.thisItem': 'this item',
  'menu.admin.emptyCategory': 'Nothing in this category yet.',
  'menu.admin.deleteCategoryTitle': 'Delete this category?',
  'menu.admin.deleteItemTitle': 'Delete this item?',
  'menu.admin.deleteCategoryDescription': 'Its items are deleted with it. To take it off the site but keep it, turn off its visibility instead.',
  'menu.admin.deleteItemDescription': 'It disappears from the website once you delete it.',
  'menu.admin.removed': 'Removed',
  'menu.admin.categoryShown': 'Category shown',
  'menu.admin.categoryHidden': 'Category hidden',
  'menu.admin.categorySaved': 'Category saved',
  'menu.admin.categoryAdded': 'Category added',
  'menu.admin.editCategory': 'Edit category',
  'menu.admin.nameHint': 'Drinks, Food, Supplements…',
  'menu.admin.order': 'Order',
  'menu.admin.orderHint': 'Lower numbers come first.',
  'menu.admin.showOnWebsite': 'Show on the website',
  'menu.admin.itemSaved': 'Item saved',
  'menu.admin.itemAdded': 'Item added',
  'menu.admin.editItem': 'Edit item',
  'menu.admin.newItem': 'New item',
  'menu.admin.description': 'Description',
  'menu.admin.price': 'Price ({currency})',
  'menu.admin.category': 'Category',
  'menu.admin.photo': 'Photo',
  'menu.admin.photoHint': 'Optional.',
};

export const ka: Record<keyof typeof en, string> = {
  'website.description': 'შეცვალეთ საჯარო ვებსაიტი და გამოაქვეყნეთ, როცა მზად იქნება.',
  'website.publishedAt': 'გამოქვეყნდა {date}',
  'website.notPublished': 'ჯერ არ გამოქვეყნებულა',
  'website.unpublishedChanges': 'გამოუქვეყნებელი ცვლილებები',
  'website.live': 'ონლაინ',
  'website.unsavedEdits': 'შეუნახავი ცვლილებები',
  'website.saveToPreview': 'წინასწარი ნახვისთვის შეინახეთ მონახაზი',
  'website.previewDraft': 'მონახაზის წინასწარი ნახვა',
  'website.saveDraft': 'მონახაზის შენახვა',
  'website.saveFirst': 'ჯერ შეინახეთ მონახაზი',
  'website.publish': 'გამოქვეყნება',
  'website.unpublish': 'გამოქვეყნების გაუქმება',
  'website.draftSaved': 'მონახაზი შენახულია',
  'website.published': 'ვებსაიტი გამოქვეყნდა',
  'website.unpublished': 'ვებსაიტის გამოქვეყნება გაუქმდა',
  'website.quarantine.title': 'თქვენი შენახული მონახაზი გვერდზე გადაიდო',
  'website.quarantine.body': 'ის აღარ აკმაყოფილებდა ვებსაიტის წესებს, ამიტომ რედაქტორმა ახალი მონახაზი გახსნა. თქვენს მოქმედ საიტზე ეს გავლენას არ ახდენს. აღადგინეთ ბოლოს გამოქვეყნებული ვერსია, რომ მისგან გააგრძელოთ, ან დაიწყეთ ახალი მონახაზიდან.',
  'website.quarantine.bodyNoRestore': 'ის აღარ აკმაყოფილებდა ვებსაიტის წესებს, ამიტომ რედაქტორმა ახალი მონახაზი გახსნა. გვერდზე გადადებული მონახაზი შენახულია და Bulk-ის მხარდაჭერას მისი აღდგენა შეუძლია.',
  'website.quarantine.reason': 'რა ვერ გაიარა: {reason}',
  'website.quarantine.restore': 'ბოლოს გამოქვეყნებული ვერსიის აღდგენა',
  'website.quarantine.dismiss': 'ამ მონახაზიდან დაწყება',
  'website.quarantine.restored': 'ბოლოს გამოქვეყნებული ვერსია მონახაზში დაბრუნდა',
  'website.tab.sections': 'სექციები',
  'website.tab.navigation': 'ნავიგაცია და ქვედა ზოლი',
  'website.tab.seo': 'SEO',
  'website.tab.social': 'სოციალური ქსელები',
  'website.tab.branding': 'ბრენდინგი',
  'website.tab.memberArea': 'წევრის გვერდი',
  'website.memberArea.cardsTitle': 'წევრის მთავარი გვერდი',
  'website.memberArea.cardsDescription': 'გადაათრიეთ ბარათები იმ რიგით, რომლითაც წევრები მათ მთავარ გვერდზე ხედავენ, და გამორთეთ არასაჭირო. ცვლილებები ვებსაიტის გამოქვეყნებისას ამოქმედდება.',
  'website.memberArea.drag': 'გადაათრიეთ რიგის შესაცვლელად',
  'website.memberArea.show': '{card}: ჩვენება',
  'website.memberArea.moduleOff': 'ამ დარბაზისთვის გამორთულია, ამიტომ წევრები მას ვერ ხედავენ',
  'website.memberArea.card.announcements': 'განცხადებები და შეთავაზებები',
  'website.memberArea.card.membership': 'აბონემენტის სტატუსი',
  'website.memberArea.card.profile': 'პროფილი',
  'website.memberArea.card.balance': 'ბალანსი და შევსება',
  'website.memberArea.card.actions': 'ყიდვა, ვარჯიშზე ჩაწერა, შევსება',
  'website.memberArea.card.visits': 'ბოლო ვიზიტები',
  'website.memberArea.card.bookings': 'მომავალი ჩაწერები',
  'website.memberArea.card.entry': 'შესასვლელი ბარათები',
  'website.memberArea.card.notifications': 'შეტყობინებები',
  'website.memberArea.card.documents': 'დოკუმენტები',
  'website.memberArea.card.payments': 'ბოლო გადახდა',
  'website.memberArea.card.quickLinks': 'სწრაფი ბმულები',
  'website.memberArea.card.trainers': 'ტრენერები',
  'website.memberArea.card.hours': 'სამუშაო საათები',
  'website.memberArea.card.barMenu': 'ბარის მენიუ',
  'website.memberArea.welcomeTitle': 'მისალმება',
  'website.memberArea.welcome': 'მისასალმებელი ტექსტი',
  'website.memberArea.welcomeHint': 'ჩანს ბარათების ზემოთ, თითოეულ ენაზე. Markdown: მუქი ტექსტი, სიები და ბმულები მუშაობს.',
  'website.memberArea.hero': 'მთავარი სურათი',
  'website.memberArea.heroHint': 'ფართო სურათი მისასალმებელი ტექსტის ზემოთ.',
  'website.memberArea.links': 'სწრაფი ბმულები',
  'website.memberArea.linksHint': 'მაქსიმუმ ექვსი ბმული, სწრაფი ბმულების ბარათში.',
  'website.memberArea.noLinks': 'სწრაფი ბმულები ჯერ არ არის.',
  'website.memberArea.addLink': 'ბმულის დამატება',
  'website.memberArea.removeLink': 'ბმულის წაშლა',
  'website.memberArea.linkLabelEn': 'წარწერა ინგლისურად',
  'website.memberArea.linkLabelKa': 'წარწერა ქართულად',
  'website.memberArea.linkHref': 'ბმული',
  'website.memberArea.linkIcon': 'ხატულა',
  'website.memberArea.badHref': 'მიუთითეთ წევრის გვერდის მისამართი, რომელიც / სიმბოლოთი იწყება, ან http:// ან https://-ით დაწყებული მისამართი.',
  'website.memberArea.icon.link': 'ბმული',
  'website.memberArea.icon.calendar': 'კალენდარი',
  'website.memberArea.icon.dumbbell': 'ჰანტელი',
  'website.memberArea.icon.coffee': 'ყავა',
  'website.memberArea.icon.user': 'ადამიანი',
  'website.memberArea.icon.phone': 'ტელეფონი',
  'website.memberArea.icon.map': 'რუკის ნიშანი',
  'website.memberArea.icon.star': 'ვარსკვლავი',
  'website.memberArea.icon.gift': 'საჩუქარი',
  'website.memberArea.icon.info': 'ინფორმაცია',
  'website.memberArea.preview': 'წინასწარი ნახვა',
  'website.memberArea.previewHint': 'წევრის მთავარი გვერდი სანიმუშო წევრით, თქვენი დარბაზის ფერებში. შენახვამდეც მიჰყვება თქვენს ცვლილებებს.',
  'website.memberArea.lookTitle': 'შესვლის გვერდებისა და წევრის გვერდის სტილი',
  'website.memberArea.lookDescription': 'მას Bulk ადგენს დიზაინის სტუდიაში.',
  'website.memberArea.lookBulk': 'Bulk-ის სტილი',
  'website.memberArea.lookBulkHint': 'შესვლის გვერდები და წევრის გვერდი ინარჩუნებს Bulk-ის ეკრანებს თქვენი შრიფტებით, კუთხეებითა და ბრენდის ფერებით. სთხოვეთ Bulk-ს, გადართოს ისინი თქვენი საიტის სტილზე.',
  'website.memberArea.lookSite': 'საიტის სტილი',
  'website.memberArea.lookSiteHint': 'თქვენს მისამართზე შესვლის გვერდები და წევრის გვერდი იყენებს თქვენი საიტის ლოგოს, შრიფტებს, ფერებსა და კუთხეებს. თანამშრომლების მისამართები ინარჩუნებს Bulk-ის სტილს.',
  'website.tab.redirects': 'გადამისამართებები',
  'website.redirects.cardTitle': 'ძველი მისამართები',
  'website.redirects.cardDescription': 'დარბაზის ძველი საიტის ბმულები (ძიების შედეგები, Instagram-ის ბიო, დაბეჭდილი QR კოდები) გადაამისამართეთ იქ, სადაც ეს შიგთავსი ახლაა. მისამართი, მაგალითად /gallery, ან hash-მისამართი, მაგალითად #/product. გამოქვეყნებისას ამოქმედდება.',
  'website.redirects.add': 'გადამისამართების დამატება',
  'website.redirects.empty': 'გადამისამართებები არ არის',
  'website.redirects.emptyHint': 'დაამატეთ თითო ძველ მისამართზე, რომელსაც ჯერ კიდევ სტუმრობენ.',
  'website.redirects.from': 'ძველი მისამართი',
  'website.redirects.to': 'გადამისამართება',
  'website.redirects.fromPlaceholder': '/gallery ან #/product',
  'website.redirects.toPlaceholder': '/plans ან https://…',
  'website.redirects.permanent': 'მუდმივი',
  'website.redirects.remove': 'გადამისამართების წაშლა',
  'website.redirects.badFrom': 'ძველი მისამართი დაიწყეთ / ან #/ სიმბოლოთი.',
  'website.redirects.badTo': 'მიუთითეთ ამ საიტის მისამართი, რომელიც / სიმბოლოთი იწყება, ან https://-ით დაწყებული მისამართი.',
  'website.navigation.description': 'ბმულები საიტის ზედა ზოლში და ტექსტი ყველა გვერდის ბოლოში.',
  'website.nav.links': 'ნავიგაციის ბმულები',
  'website.nav.linkItem': 'ბმული {n}',
  'website.nav.addLink': 'ბმულის დამატება',
  'website.nav.noLinks': 'ნავიგაციის ბმულები ჯერ არ არის.',
  'website.nav.hrefHint': 'მისამართი, მაგ. /classes, ან სრული URL',
  'website.nav.footerText': 'ქვედა ზოლის ტექსტი',
  'website.seo.cardTitle': 'საძიებო სისტემების პარამეტრები',
  'website.seo.cardDescription': 'როგორ ჩანს საიტი Google-ში და სოციალურ ქსელებში გაზიარებისას.',
  'website.seo.title': 'გვერდის სათაური',
  'website.seo.titleHint': 'ჩანს ბრაუზერის ჩანართში და ძიების შედეგებში.',
  'website.seo.description': 'მეტა აღწერა',
  'website.seo.robotsIndex': 'საძიებო სისტემებისთვის საიტის ინდექსირების დაშვება',
  'website.seo.canonicalUrl': 'კანონიკური URL',
  'website.seo.canonicalUrlHint': 'არასავალდებულო. გამოიყენეთ, თუ საიტი რამდენიმე დომენზეა ხელმისაწვდომი.',
  'website.seo.ogImage': 'სურათი სოციალურ ქსელებში გაზიარებისთვის',
  'website.social.cardTitle': 'სოციალური ქსელების პროფილები',
  'website.social.cardDescription': 'ჩანს ქვედა ზოლში. თუ ველს ცარიელს დატოვებთ, ის დაიმალება.',
  'website.social.facebook': 'Facebook',
  'website.social.instagram': 'Instagram',
  'website.social.tiktok': 'TikTok',
  'website.social.youtube': 'YouTube',
  'website.publishTitle': 'გამოვაქვეყნოთ ვებსაიტი?',
  'website.publishDescription': 'შენახული მონახაზი ჩაანაცვლებს იმას, რასაც ვიზიტორები ახლა ხედავენ.',
  'website.unpublishTitle': 'გავთიშოთ ვებსაიტი?',
  'website.unpublishDescription': 'ხელახლა გამოქვეყნებამდე ვიზიტორები დროებით გვერდს დაინახავენ. მონახაზი შენარჩუნდება.',
  'website.servedFrom': 'გამოქვეყნების შემდეგ საჯარო საიტი ხელმისაწვდომი იქნება მისამართზე {host}.',
  'website.servedFromYourDomain': 'გამოქვეყნების შემდეგ საჯარო საიტი ხელმისაწვდომი იქნება თქვენი დარბაზის დომენზე.',
  'website.branding.saved': 'ბრენდინგი შენახულია',
  'website.branding.title': 'ბრენდი',
  'website.branding.description': 'ფერები, შრიფტი და ლოგო, რომლებიც საჯარო ვებსაიტზე გამოიყენება.',
  'website.branding.primary': 'ძირითადი',
  'website.branding.primaryHint': 'ღილაკები, გამოყოფები და აქცენტები',
  'website.branding.primaryAria': 'ძირითადი ფერი',
  'website.branding.secondary': 'მეორადი',
  'website.branding.secondaryHint': 'ბარათები და მეორადი ზედაპირები',
  'website.branding.secondaryAria': 'მეორადი ფერი',
  'website.branding.background': 'ფონი',
  'website.branding.backgroundHint': 'გვერდის ფონი',
  'website.branding.backgroundAria': 'ფონის ფერი',
  'website.branding.text': 'ტექსტი',
  'website.branding.textHint': 'ძირითადი ტექსტი ფონზე',
  'website.branding.textAria': 'ტექსტის ფერი',
  'website.branding.font': 'შრიფტი',
  'website.branding.fontHint': 'საჯარო საიტზე იტვირთება Google Fonts-იდან, თუ იქ ხელმისაწვდომია.',
  'website.branding.designed': 'ამ საიტის დიზაინი Bulk-მა შექმნა',
  'website.branding.designedText': 'შრიფტები, თავსართი, ქვედა ზოლი და ფერთა სქემები დიზაინიდან მოდის. აქ მოცემული ოთხი ფერისგან იქმნება ყველა სქემა, ამიტომ ცვლილება მთელ საიტზე გამოჩნდება.',
  'website.branding.logo': 'ლოგო',
  'website.branding.logoHint': 'SVG ან PNG გამჭვირვალე ფონით.',
  'website.branding.favicon': 'ფავიკონი',
  'website.branding.faviconHint': 'კვადრატული, მინიმუმ 64×64.',
  'website.branding.save': 'ბრენდინგის შენახვა',
  'website.branding.preview': 'წინასწარი ნახვა',
  'website.branding.sampleHeadline': '{gym} — ივარჯიშეთ უფრო ძლიერად',
  'website.branding.sampleText': 'აბონემენტები, ვარჯიშები და ტრენერები ერთ სივრცეში.',
  'website.branding.sampleButton': 'გაწევრიანდით ახლავე',
  'website.pages.home': 'მთავარი',
  'website.pages.add': 'გვერდის დამატება',
  'website.pages.title': 'გვერდი',
  'website.pages.description': 'სად მდებარეობს გვერდი და როგორ ჩანს მენიუში.',
  'website.pages.titleHint': 'ჩანს ბრაუზერის ჩანართში და მენიუშიც, თუ ქვემოთ სხვა წარწერას არ მიუთითებთ.',
  'website.pages.address': 'მისამართი',
  'website.pages.showInMenu': 'მენიუში ჩვენება',
  'website.pages.showInMenuHint': 'დამალული გვერდი ბმულით მაინც იხსნება.',
  'website.pages.inSiteMenu': 'საიტის მენიუში',
  'website.pages.menuLabel': 'წარწერა მენიუში',
  'website.pages.menuLabelHint': 'არასავალდებულო. თუ ცარიელს დატოვებთ, გამოჩნდება სათაური.',
  'website.pages.delete': 'გვერდის წაშლა',
  'website.pages.deleteTitle': 'წავშალოთ ეს გვერდი?',
  'website.pages.deleteDescription': 'გვერდთან ერთად წაიშლება მისი სექციებიც. გამოქვეყნების შემდეგ ამ გვერდის ბმულზე გადასული ვიზიტორი „გვერდი ვერ მოიძებნა“ შეტყობინებას ნახავს. თუ გსურთ გვერდის შენარჩუნება და მხოლოდ მენიუდან მოხსნა, ამის ნაცვლად გამორთეთ „საიტის მენიუში“.',
  'website.openLive': 'საჯარო საიტი',
  'canvas.title': 'გვერდის გადახედვა',
  'canvas.show': 'გვერდის ჩვენება',
  'canvas.hide': 'გვერდის დამალვა',
  'canvas.device': 'ეკრანის ზომა',
  'canvas.device.desktop': 'კომპიუტერი',
  'canvas.device.tablet': 'პლანშეტი',
  'canvas.device.phone': 'ტელეფონი',
  'canvas.hidden': 'დამალულია',
  'canvas.incomplete': 'შეავსეთ, რაც ამ ბლოკს სჭირდება, რომ აქ გამოჩნდეს.',
  'canvas.empty': 'ამ გვერდზე ბლოკები ჯერ არ არის. დაამატეთ ბიბლიოთეკიდან.',
  'sections.empty': 'სექციები არ არის',
  'sections.visible': 'ხილული',
  'sections.selectTitle': 'აირჩიეთ სექცია',
  'sections.selectHint': 'შინაარსის შესაცვლელად აირჩიეთ სექცია მარცხნივ.',
  'sections.heading': 'სათაური',
  'sections.intro': 'შესავალი',
  'sections.body': 'ძირითადი ტექსტი',
  'sections.text': 'ტექსტი',
  'sections.image': 'სურათი',
  'sections.button': 'ღილაკი',
  'sections.hero.label': 'მთავარი ბანერი',
  'sections.hero.description': 'დიდი გამხსნელი ბანერი თქვენი მთავარი სათაურითა და მოქმედების ღილაკებით.',
  'sections.hero.subtitle': 'ქვესათაური',
  'sections.hero.image': 'ფონის სურათი',
  'sections.hero.video': 'ფონის ვიდეოს URL',
  'sections.hero.videoHint': 'არასავალდებულო MP4 ან სტრიმინგის URL',
  'sections.hero.primaryCta': 'მთავარი ღილაკი',
  'sections.hero.secondaryCta': 'მეორადი ღილაკი',
  'sections.about.label': 'ჩვენ შესახებ',
  'sections.about.description': 'ვინ ხართ და რით გამოირჩევა თქვენი დარბაზი.',
  'sections.about.highlights': 'უპირატესობები',
  'sections.about.highlightItem': 'უპირატესობა {n}',
  'sections.about.addHighlight': 'უპირატესობის დამატება',
  'sections.about.noHighlights': 'უპირატესობები ჯერ არ არის.',
  'sections.plans.label': 'პაკეტები',
  'sections.plans.description': 'აბონემენტის პაკეტები ფასებითა და ყიდვის ღილაკით.',
  'sections.plans.showAll': 'ყველა საჯარო პაკეტის ჩვენება',
  'sections.plans.showAllHint': 'გამორთეთ, რომ პაკეტები ქვემოთ ხელით აირჩიოთ.',
  'sections.plans.pick': 'საჩვენებელი პაკეტები',
  'sections.plans.groupByBranch': 'ფილიალების მიხედვით დაჯგუფება',
  'sections.plans.groupByBranchHint': 'პაკეტები თითოეული ფილიალის სახელის ქვეშ ჩამოიწერება, ერთი ფილიალის შემთხვევაშიც. ყველა ფილიალში მოქმედი პაკეტი თითოეულის ქვეშ ჩანს.',
  'sections.plans.none': 'საჯარო პაკეტები ჯერ არ არის.',
  'sections.classes.label': 'ვარჯიშები',
  'sections.classes.description': 'ჯგუფური ვარჯიშები და კვირის განრიგი.',
  'sections.classes.showSchedule': 'კვირის განრიგის ჩვენება',
  'sections.trainers.label': 'ტრენერები',
  'sections.trainers.description': 'თქვენი ტრენერების გუნდი საიტზე.',
  'sections.facilities.label': 'ინფრასტრუქტურა',
  'sections.facilities.description': 'აღჭურვილობა, სივრცეები და კომფორტი.',
  'sections.facilities.item': 'ობიექტი {n}',
  'sections.facilities.add': 'ობიექტის დამატება',
  'sections.facilities.none': 'ობიექტები ჯერ არ არის.',
  'sections.gallery.label': 'გალერეა',
  'sections.gallery.description': 'ფოტოების ბადე.',
  'sections.gallery.images': 'სურათები',
  'sections.gallery.removeImage': 'სურათის ამოღება',
  'sections.gallery.addHint': 'ატვირთეთ ან აირჩიეთ სურათი გალერეაში დასამატებლად.',
  'sections.testimonials.label': 'შეფასებები',
  'sections.testimonials.description': 'კმაყოფილი წევრების სიტყვები.',
  'sections.testimonials.item': 'შეფასება {n}',
  'sections.testimonials.add': 'შეფასების დამატება',
  'sections.testimonials.none': 'შეფასებები ჯერ არ არის.',
  'sections.testimonials.author': 'ავტორი',
  'sections.testimonials.quote': 'ციტატა',
  'sections.testimonials.rating': 'რეიტინგი (1–5)',
  'sections.faq.label': 'ხშირი კითხვები',
  'sections.faq.description': 'ხშირად დასმული კითხვები.',
  'sections.faq.questions': 'კითხვები',
  'sections.faq.item': 'კითხვა {n}',
  'sections.faq.add': 'კითხვის დამატება',
  'sections.faq.none': 'კითხვები ჯერ არ არის.',
  'sections.faq.question': 'კითხვა',
  'sections.faq.answer': 'პასუხი',
  'sections.contact.label': 'კონტაქტი',
  'sections.contact.description': 'მისამართი, ტელეფონი, სამუშაო საათები და საკონტაქტო ფორმა.',
  'sections.contact.address': 'მისამართი',
  'sections.contact.hours': 'სამუშაო საათები',
  'sections.contact.showForm': 'საკონტაქტო ფორმის ჩვენება',
  'sections.map.label': 'რუკა',
  'sections.map.description': 'სად მდებარეობთ.',
  'sections.map.latitude': 'განედი',
  'sections.map.longitude': 'გრძედი',
  'sections.map.embedUrl': 'რუკის ჩასაშენებელი URL',
  'sections.map.embedUrlHint': 'Google Maps-ის „Embed a map“ ბმული',
  'sections.richText.label': 'ტექსტი',
  'sections.richText.description': 'თავისუფალი ტექსტი — სათაურები, აბზაცები, სიები და ბმულები — იმ შინაარსისთვის, რომელიც სხვა სექციებში არ ჯდება.',
  'sections.richText.headingHint': 'არასავალდებულო. დატოვეთ ცარიელი, თუ ტექსტს სათაური არ სჭირდება.',
  'sections.richText.bodyHint': 'Markdown: # სათაური, **მუქი**, - სია, [ბმული](https://…).',
  'sections.richText.width': 'სიგანე',
  'sections.menu.label': 'მენიუ',
  'sections.menu.description': 'კაფისა და მაღაზიის ჩამონათვალი. პოზიციები იმართება „მენიუს“ გვერდზე; ეს სექცია წყვეტს, რა გამოჩნდეს საიტზე.',
  'sections.menu.categories': 'კატეგორიები',
  'sections.menu.categoriesHint': 'დატოვეთ ცარიელი, რომ ყველა ხილული კატეგორია გამოჩნდეს.',
  'sections.menu.layout': 'განლაგება',
  'sections.menu.none': 'მენიუს კატეგორიები ჯერ არ არის — დაამატეთ ისინი „მენიუს“ გვერდზე.',
  'sections.menu.category': 'კატეგორია',
  'sections.menu.hidden': '(დამალული)',
  'sections.cta.label': 'მოწოდება მოქმედებისკენ',
  'sections.cta.description': 'დასკვნითი ბანერი, რომელიც ვიზიტორებს გაწევრიანებისკენ უბიძგებს.',
  'sections.link.hint': 'მისამართი, მაგ. /plans, ან სრული URL',
  'editor.title': 'სათაური',
  'editor.label': 'წარწერა',
  'editor.link': 'ბმული',
  'editor.add': 'დამატება',
  'editor.remove': 'ამოღება',
  'editor.moveUp': 'ზემოთ აწევა',
  'editor.moveDown': 'ქვემოთ ჩამოწევა',
  'editor.preview': 'წინასწარი ნახვა',
  'editor.nothingToPreview': 'საჩვენებელი ჯერ არაფერია.',
  'media.asset': 'ფაილი {id}…',
  'media.upload': 'ატვირთვა',
  'media.svgUnreadable': 'ამ SVG-ის წაკითხვა ვერ მოხერხდა. ხელახლა შეინახეთ დიზაინის პროგრამიდან ან ატვირთეთ PNG.',
  'media.choose': 'არჩევა',
  'media.library': 'მედიაბიბლიოთეკა',
  'media.uploadedAs.LOGO': 'ლოგოდ ატვირთული სურათები',
  'media.uploadedAs.FAVICON': 'ფავიკონად ატვირთული სურათები',
  'media.uploadedAs.WEBSITE': 'ვებსაიტისთვის ატვირთული სურათები',
  'media.uploadedAs.TRAINER': 'ტრენერისთვის ატვირთული სურათები',
  'media.uploadedAs.GALLERY': 'გალერეისთვის ატვირთული სურათები',
  'media.uploadedAs.MEMBER': 'წევრისთვის ატვირთული სურათები',
  'media.uploadedAs.DOCUMENT': 'დოკუმენტად ატვირთული სურათები',
  'media.empty.title': 'სურათები ჯერ არ არის',
  'media.empty.description': 'ბიბლიოთეკის შესაქმნელად ატვირთეთ სურათი.',
  'content.description': 'წესები და პირობები, კონფიდენციალურობის პოლიტიკა, თანხის დაბრუნების პოლიტიკა, შიდა წესები, საავტორო უფლებებისა და cookie-ფაილების შეტყობინებები, რომლებიც საჯარო საიტზე ჩანს და რომლებსაც წევრები ეთანხმებიან. ნაგულისხმევი ტექსტები მომხმარებელთა უფლებებისა და პერსონალურ მონაცემთა დაცვის გავრცელებულ პრაქტიკას მიჰყვება; გამოქვეყნებამდე მიეცით იურისტს, რომ თქვენი იურისდიქციისთვის გადაამოწმოს.',
  'content.newPage': 'ახალი გვერდი',
  'content.empty.title': 'გვერდები ჯერ არ არის',
  'content.empty.description': 'შექმენით წესები და პირობები, კონფიდენციალურობის პოლიტიკა და შიდა წესები, რომ წევრებმა წაიკითხონ და დაეთანხმონ.',
  'content.createPage': 'გვერდის შექმნა',
  'content.col.page': 'გვერდი',
  'content.col.slug': 'მისამართი',
  'content.col.kind': 'ტიპი',
  'content.col.accepted': 'დაეთანხმა',
  'content.col.updated': 'განახლდა',
  'content.view': 'ნახვა',
  'content.publish': 'გამოქვეყნება',
  'content.unpublish': 'გამოქვეყნების გაუქმება',
  'content.publishedVersion': 'გამოქვეყნდა ვერსია {version}',
  'content.unpublished': 'გვერდის გამოქვეყნება გაუქმდა',
  'content.deleted': 'გვერდი წაიშალა',
  'content.created': 'გვერდი შეიქმნა',
  'content.settingSaved': 'პარამეტრი შენახულია',
  'content.publishNamed': 'გამოვაქვეყნოთ „{title}“?',
  'content.unpublishNamed': 'გავაუქმოთ „{title}“ გვერდის გამოქვეყნება?',
  'content.deleteNamed': 'წავშალოთ „{title}“?',
  'content.unpublishDescription': 'გვერდი გაქრება საჯარო საიტიდან და წევრების დოკუმენტებიდან. მონახაზი შენარჩუნდება.',
  'content.deleteDescription': 'მონახაზი წაიშლება. ამ მოქმედების გაუქმება შეუძლებელია.',
  'content.deletePage': 'გვერდის წაშლა',
  'content.gate.title': 'ონლაინ გადახდამდე თანხმობის მოთხოვნა',
  'content.gate.hint': 'ონლაინ გადახდამდე წევრი უნდა დაეთანხმოს „საჭიროებს თანხმობას“ ნიშნით მონიშნული ყველა გვერდის მიმდინარე ვერსიას. მიმღებთან გაყიდვისას თანხმობა ამის ნაცვლად გაყიდვის ფანჯარაში ფიქსირდება.',
  'content.titleRequired': 'შეიყვანეთ სულ მცირე ინგლისური სათაური',
  'content.newDescription': 'ახალი გვერდი მონახაზად იქმნება. დაწერეთ შინაარსი რედაქტორში და შემდეგ გამოაქვეყნეთ.',
  'content.slugHint': 'საჯარო მისამართი: /p/slug',
  'content.requiresAcceptance': 'წევრები უნდა დაეთანხმონ',
  'content.requiresAcceptanceHint': 'ყოველი ახალი ვერსიის შემდეგ თანხმობა ხელახლა მოეთხოვებათ.',
  'content.showInFooter': 'ბმული საიტის ქვედა ზოლში',
  'content.showInFooterHint': 'გამოქვეყნების შემდეგ.',
  'content.unsavedChanges': 'შეუნახავი ცვლილებები',
  'content.viewPublic': 'საჯარო გვერდის ნახვა',
  'content.pageDescription': 'მისამართი, ტიპი და სად ჩანს გვერდი.',
  'content.readOnly': 'ამ გვერდის ნახვა შეგიძლიათ, შეცვლა — არა.',
  'content.sortOrder': 'რიგითობა',
  'content.sortOrderHint': 'ქვედა ზოლში ნაკლები რიცხვი პირველი ჩანს.',
  'content.content': 'შინაარსი',
  'content.contentDescription': 'იწერება Markdown-ით: # სათაურები, - სიები, **მუქი** და [ბმულები](https://…).',
  'content.bodyAria': 'ტექსტი ({language})',
  'content.version': 'ვერსია',
  'content.published': 'გამოქვეყნდა',
  'content.draftUpdated': 'მონახაზი განახლდა',
  'content.publishVersion': 'ვერსია {version}-ის გამოქვეყნება',
  'content.publishVersionTitle': 'გამოვაქვეყნოთ ვერსია {version}?',
  'content.publishThisTitle': 'გამოვაქვეყნოთ ეს გვერდი?',
  'content.unpublishThisTitle': 'გავაუქმოთ ამ გვერდის გამოქვეყნება?',
  'content.hint.saveFirst': 'გამოქვეყნებამდე შეინახეთ მონახაზი.',
  'content.hint.upToDate': 'საჯარო საიტზე ბოლო შენახული მონახაზი ჩანს.',
  'content.hint.publishMakesPublic': 'გამოქვეყნებით შენახული მონახაზი საჯარო ხდება.',
  'content.status.draft': 'მონახაზი',
  'content.status.published': 'გამოქვეყნებულია v{version}',
  'content.publishReaccept': 'შენახული მონახაზი საჯარო საიტზე ვერსია {next} გახდება. ვერსია {current}-ზე დათანხმებულ წევრებს ვერსია {next}-ზე თანხმობა მოეთხოვებათ.',
  'content.publishAccept': 'შენახული მონახაზი საჯარო საიტზე ვერსია {next} გახდება და წევრებს მასზე თანხმობა მოეთხოვებათ.',
  'content.publishPlain': 'შენახული მონახაზი საჯარო საიტზე ვერსია {next} გახდება.',
  'content.members.one': '{count} წევრი',
  'content.members.other': '{count} წევრი',
  'enum.contentPageKind.LEGAL': 'იურიდიული',
  'enum.contentPageKind.PAGE': 'გვერდი',
  'enum.contentPageKind.NOTICE': 'შეტყობინება',
  'menu.admin.intro': 'რას ყიდის დარბაზი აბონემენტების გარდა — კაფისა და მაღაზიის ჩამონათვალი, რომელიც ვებსაიტზე ჩანს. აქედან Bulk-ით არაფერი იყიდება.',
  'menu.admin.newCategory': 'ახალი კატეგორია',
  'menu.admin.empty.title': 'მენიუ ჯერ არ არის',
  'menu.admin.empty.description': 'დაამატეთ კატეგორია — სასმელები, საკვები, დანამატები — და შემდეგ მისი პოზიციები.',
  'menu.admin.addCategory': 'კატეგორიის დამატება',
  'menu.admin.untitled': 'უსახელო',
  'menu.admin.hiddenBadge': 'დამალული',
  'menu.admin.hidden': 'დამალული',
  'menu.admin.items.one': '{count} პოზიცია',
  'menu.admin.items.other': '{count} პოზიცია',
  'menu.admin.categoryVisible': 'კატეგორია ხილულია',
  'menu.admin.item': 'პოზიცია',
  'menu.admin.thisCategory': 'ეს კატეგორია',
  'menu.admin.thisItem': 'ეს პოზიცია',
  'menu.admin.emptyCategory': 'ამ კატეგორიაში ჯერ არაფერია.',
  'menu.admin.deleteCategoryTitle': 'წავშალოთ ეს კატეგორია?',
  'menu.admin.deleteItemTitle': 'წავშალოთ ეს პოზიცია?',
  'menu.admin.deleteCategoryDescription': 'კატეგორიასთან ერთად წაიშლება მისი პოზიციებიც. თუ გსურთ, საიტიდან მოხსნათ, მაგრამ შეინარჩუნოთ, ამის ნაცვლად გამორთეთ მისი ხილვადობა.',
  'menu.admin.deleteItemDescription': 'წაშლის შემდეგ ვებსაიტიდან გაქრება.',
  'menu.admin.removed': 'წაიშალა',
  'menu.admin.categoryShown': 'კატეგორია გამოჩნდა',
  'menu.admin.categoryHidden': 'კატეგორია დაიმალა',
  'menu.admin.categorySaved': 'კატეგორია შენახულია',
  'menu.admin.categoryAdded': 'კატეგორია დაემატა',
  'menu.admin.editCategory': 'კატეგორიის რედაქტირება',
  'menu.admin.nameHint': 'სასმელები, საკვები, დანამატები…',
  'menu.admin.order': 'რიგითობა',
  'menu.admin.orderHint': 'ნაკლები რიცხვი პირველი ჩანს.',
  'menu.admin.showOnWebsite': 'ვებსაიტზე ჩვენება',
  'menu.admin.itemSaved': 'პოზიცია შენახულია',
  'menu.admin.itemAdded': 'პოზიცია დაემატა',
  'menu.admin.editItem': 'პოზიციის რედაქტირება',
  'menu.admin.newItem': 'ახალი პოზიცია',
  'menu.admin.description': 'აღწერა',
  'menu.admin.price': 'ფასი ({currency})',
  'menu.admin.category': 'კატეგორია',
  'menu.admin.photo': 'ფოტო',
  'menu.admin.photoHint': 'არასავალდებულო.',
};
